import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TimecardEntry {
  date: string;
  day: string;
  month: string;
  inTime: string;
  outTime?: string;
  TotalTime?: string;
  hoursWorked?: string;
}

interface TimecardState {
  data: TimecardEntry[];
}

const initialState: TimecardState = {
  data: [
    { date: '07', day: 'Fri', month: 'Feb', inTime: '10:09 am', outTime: '', TotalTime: '', hoursWorked: '' },
    { date: '06', day: 'Thu', month: 'Feb', inTime: '10:19 am', outTime: '', TotalTime: '', hoursWorked: '' },
    { date: '05', day: 'Wed', month: 'Feb', inTime: '10:22 am', outTime: '07:08 pm', TotalTime: '8h 45m', hoursWorked: '8h 45m' },
    { date: '04', day: 'Tue', month: 'Feb', inTime: '10:15 am', outTime: '06:43 pm', TotalTime: '8h 28m', hoursWorked: '8h 28m' },
    { date: '03', day: 'Mon', month: 'Feb', inTime: '10:06 am', outTime: '', TotalTime: '', hoursWorked: '' },
  ],
};

export const timecardSlice = createSlice({
  name: 'Emp_Timecard',
  initialState,
  reducers: {
    fetchTimecard: (state) => state, 
  },
});

export const { fetchTimecard } = timecardSlice.actions;
export default timecardSlice.reducer;